import { render, staticRenderFns } from "./VideoPageCard.vue?vue&type=template&id=51ab1f3c&scoped=true&"
import script from "./VideoPageCard.vue?vue&type=script&lang=js&"
export * from "./VideoPageCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoPageCard.vue?vue&type=style&index=0&id=51ab1f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ab1f3c",
  null
  
)

export default component.exports